import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SapWarehouse } from '../models/sap-warehouse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SapWarehoseService {

  constructor( private http:HttpClient ) { }

  getWarehouses() : Promise<SapWarehouse[]> {
    return this.http.get<SapWarehouse[]>('/api/warehouses-sap').toPromise();
  }
}
